<template>
  <div class="auth-cabinet">
    <header>
      <template v-if="groupTemplate">
        <component :is="`header-information-navigation-${sid}`" />
      </template>
      <information-navigation v-else />
    </header>
    <main>
      <b-container fluid class="p-0" id="content">
        <b-container>
          <b-row>
            <b-col cols="12">
              <router-view />
            </b-col>
          </b-row>
        </b-container>
      </b-container>
    </main>
    <cabinet-footer />
  </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import InformationNavigation from '@/components/Header/InformationNavigation.vue';
import HeaderInformationNavigationJig from '@/components/Themes/HeaderInformationNavigationJig.vue';
import HeaderInformationNavigationTalentpool from '@/components/Themes/HeaderInformationNavigationTalentpool.vue';
import HeaderInformationNavigationT4a from '@/components/Themes/HeaderInformationNavigationT4a.vue';
import HeaderInformationNavigationNcph from '@/components/Themes/HeaderInformationNavigationNcph.vue';
import HeaderInformationNavigationWconat from '@/components/Themes/HeaderInformationNavigationWconat.vue';
import HeaderInformationNavigationAmseu from '@/components/Themes/HeaderInformationNavigationAmseu.vue';
import PagesNavigation from '@/components/Header/PagesNavigation.vue';
import CabinetFooter from '@/components/Cabinet/CabinetFooter.vue';
import { AppModule } from '@/store/modules/app';
import { UserModule } from '@/store/modules/user';
import HeaderInformationNavigationEdunet from '@/components/Themes/HeaderInformationNavigationEdunet.vue';
import { group, groupAba } from '@/config/configuration';
import HeaderInformationNavigationAbaooe
  from '@/components/Themes/HeaderInformationNavigationAbaooe.vue';

@Component({
  components: {
    InformationNavigation,
    PagesNavigation,
    CabinetFooter,
    HeaderInformationNavigationJig,
    HeaderInformationNavigationTalentpool,
    HeaderInformationNavigationEdunet,
    HeaderInformationNavigationT4a,
    HeaderInformationNavigationNcph,
    HeaderInformationNavigationWconat,
    HeaderInformationNavigationAbaooe,
    HeaderInformationNavigationAmseu,
  },
})
export default class CabinetTemplate extends Vue {
  get sid() {
    return AppModule.sid;
  }

  get languageSid() {
    return AppModule.languageSid;
  }

  get accessTokenApplicant() {
    return UserModule.accessTokenApplicant;
  }

  get accessTokenConsultant() {
    return UserModule.accessTokenConsultant;
  }

  get accessTokenCompany() {
    return UserModule.accessTokenCompany;
  }

  get groupTemplate() {
    return group(this.sid) || groupAba(this.sid);
  }
}
</script>

<style lang="scss" scoped>
// Sticky footer: while the cabinet is still loading (page reload, language switch)
// the content is short, and without this the footer jumps up right under the header.
.auth-cabinet {
  display: flex;
  flex-direction: column;
  min-height: 100vh;

  > main {
    flex: 1 0 auto;
  }
}
</style>
